<template>
  <div class="c mb-xxl">
    <div class="rop rop-x">
      <div class="rop-t"><h2 class="h3 fc-2">Pripoistenie – voliteľné</h2></div>
      <div class="rop-c">
        <div class="rop-e">
          <div><strong>Odporúčaný rozsah</strong></div>
        </div>
        <div class="rop-b">
          <div><strong>Moja voľba</strong></div>
        </div>
      </div>
    </div>

    <div v-for="(item) in insurancesPersonalized" v-bind:key="item.code" class="rop">
      <div class="rop-t">
        <span v-if="!item.tooltip?.description">{{ item.label }}

        </span>
        <div v-else>

          <div :class="{ mb: item.description }">{{ item.label }}
            <InfoTooltip class="tooltip" v-if="item.tooltip" :text="item.tooltip.description" :link="item.tooltipLink" :linkText="item.tooltip.linkText" />
            <SportInfoTooltip class="tooltip" v-if="item.description" :text="item.description" />
          </div>
          <div class="description">
            <div class="mb">
              <div class="ps" v-if="item.tooltip.description" v-html="item.tooltip.description"></div>
              <a :href="item.tooltipLink" target="_blank" >{{ item.tooltip.linkText }}</a>
            </div>
            <div v-if="item.description">
              <div class="ps" v-html="item.description"></div>
              <a href="/attachments/short_sk/SPORT.pdf" target="_blank" >Podrobný popis športov</a>
            </div>
          </div>
        </div>


      </div>
      <div class="rop-c">
        <div class="rop-e">
          <div v-if="!item.preselected" class="ico fc-2"></div>
          <div v-else class="ico fc-1"></div>
        </div>
        <div class="rop-b">
          <label>
            <input type="checkbox" v-model="localValue" name="additional_insurances" :value="item.code" style="visibility: hidden; width: 1px; height: 1px; position: absolute;" />
            <div class="tgc">
              <div :class="{tgc_n: true, tgc_y: localValue.includes(item.code)}">
                <div class="ico"></div>
              </div>
              <div :class="{tgc_n: true, tgc_x: !localValue.includes(item.code)}">
                <div class="ico"></div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="rop rop-x">
      <div class="rop-t"><h3 class="h4">Cena vrátane pripoistení</h3></div>
      <div class="rop-c">
        <div class="rop-e">
          <div class="h4">{{ formatCurrency(recomendedPrice, 'EUR') }} </div>
        </div>
        <div class="rop-b">
          <div class="h4">{{ formatCurrency(selectedPrice, 'EUR') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import InfoTooltip from "@/components/InfoTooltip.vue";
import SportInfoTooltip from "@/components/SportInfoTooltip.vue";

export default {
  name: 'AdditionalInsurances',
  components: {SportInfoTooltip, InfoTooltip},
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    formData: Object,
    daysCount: Number,
    productPrice: Number,
    product: String
  },
  mounted() {
    this.localValue = this.recomendedPersonalizedItems.map((item) => item.code)
  },
  data() {
    return {
      localValue: [],
      insurances: {
        AIRPLANE_PACKAGE: {
          travelReason: [

          ],
          travelingBy: [
              'PLANE'
          ],
          code: 'AIRPLANE_PACKAGE',


          price: 0.33,
          label: 'Letecký balík',
          tooltip: {
            description:
                '<p><em>oneskorenie batožiny – limit 200 EUR</em>\n' +
                '<br />v prípade oneskoreného dodania riadne odbavenej batožiny o viac ako 4 hodiny od plánovaného príletu máte nárok na náhradu preukázateľne vynaložených nákladov na nákup oblečenie, vecí osobnej hygieny</p>\n' +
                '<p><em>oneskorený let alebo zrušený let – limit 200 EUR</em><br />pri omeškaní letu o viac ako 4 hodiny alebo zrušení letu máte nárok na náhradu nevyhnutných a primeraných nákladov na stravu, ubytovanie, veci osobnej hygieny</p>\n' +
                '<p><em>zmeškanie letu poisteným – limit 200 EUR</em><br />ak sa nedostavíte na letisko včas, kvôli poruche verejného dopravného prostriedku alebo havárii / poruche vozidla cestou na letisko</p>\n' +
                '<p><em>uviaznutie na letisku – limit 600 EUR</em><br />v prípade oneskorenia medzinárodného leteckého spojenia o viac ako 24 hodín máte nárok na náhradu za ubytovanie, dopravu, jedlo a nápoje, núdzové nákupy</p>\n' +
                '<p><em>predĺžené parkovanie – limit 100 EUR</em><br />omeškanie spiatočného letu o viac ako 8 hodín</p>',
            linkText: 'viac INFO vo VPP KCP 05/2025 strana 22-23',
            page: 22
          }

        },
        WINTER_SPORTS: {
          travelReason: [
            'SKI_TRIP'
          ],
          code: 'WINTER_SPORTS',
          price: 1,
          label: 'Zimné športy',
          //description: '<strong>Zimné</strong> - sú kryté ak bolo dojednané voliteľné pripoistenie Zimných športov, ak sú vykonávané rekreačne a neprofesionálne<br></div>',
          tooltip: {
            description:
                "<p><strong>Zimné</strong> - sú kryté ak bolo dojednané voliteľné pripoistenie Zimných športov, ak sú vykonávané rekreačne a neprofesionálne<br><a href=\"/attachments/short_sk/SPORT.pdf\" target=\"_blank\">Otvoriť podrobný popis športov</a></p>" +
                "<p>Pripoistenie kryje riziká v základnom rozsahu – aj počas výkonu zimných športov,</p>\n" +
                "<p>bez pripoistenia sú tieto aktivity nepoistené - t.j. poisťovna nenahradí liečebné náklady, trvalé následky úrazu, zodpovednosť za škody, atd. vzniknuté pri športových aktivitách.</p>\n" +
                "<p>Naviac máte v cene pripoistenia zahrnuté - až do limitu 20 EUR na deň max. 250 EUR</p>\n" +
                "<p><em>úhrada nákladov na skipas </em><br />ak nemôžete zakúpený skipas využiť v prípade zhoršeného zdravotného stravu, následkom náhleho ochorenia alebo úrazu</p>\n" +
                "<p><em>odškodnenie v prípade uzavretia zjazdovky</em><br />z dôvodu nepriaznivých poveternostných podmienok – v období id 15.decembra do 15 marca- do vzdialenosti 30 km od miesta ubytovania</p>\n" +
                "<p><em>úhrada nákladov na zapožičanie lyžiarskeho výstroja</em></br />ak ste nemohli zapožičaný výstroj používať z dôvodu úrazu / náhleho ochorenia, alebo z dôvodu straty – ak bol lyžiarsky výstroj v úschove n základe potvrdenia.</p>",
            linkText: 'viac INFO vo VPP KCP 05/2025 strana 29',
            page: 29
          }

        },
        SPORT_EQUIPMENT: {
          code: 'SPORT_EQUIPMENT',
          travelReason: [
            'SKI_TRIP', 'SPORTS'
          ],
          price: 0.4,
          label: 'Športové vybavenie',
          tooltip: {
            description:
                '<p>Pripoistenie športového vybavenia pre amatérsky šport sa vzťahuje na stratu, poškodenie, zničenie dopravcom, poškodenie pri dopravnej nehode alebo pri úraze poisteného, krádež vlámaním, lúpež alebo vandalizmus.</p>\n' +
                '<p>Poisťovňa Vám nahradí náklady na opravu poškodeného športového vybavenia – alebo znovunadobudnutie až do výšky časovej ceny - až do limitu 500 EUR. Výpočet časovej ceny až do veku 5 rokov od zakúpenia športového vybavenia je uvedený v poistných podmienkach. Bežné opotrebenie nie je poistením kryté.</p>',
            linkText: 'viac INFO vo VPP KCP 05/2025 strana 27-28',
            //link: '/attachments/short_sk/VPP%20KCP%2005_2025[17].pdf',
            page: 27
          },
          hasSportLink: true
        },
        EXTREME_SPORTS: {
          code: 'EXTREME_SPORTS',
          price: 1.5,
          label: 'Extrémne a rizikové športy',
          removeWhenOld: true,
          //description: '<strong>Rizikové a Exrémne</strong> sú kryté ak bolo dojednané voliteľné pripoistenie Extrémnych a Rizikových športov, pokiaľ boli dodržané miestne bezpečnostné predpisy a použitá bezpečnostná výbava',
          tooltip: {
            description:
                "<p><strong>Rizikové a Exrémne</strong> sú kryté ak bolo dojednané voliteľné pripoistenie Extrémnych a Rizikových športov, pokiaľ boli dodržané miestne bezpečnostné predpisy a použitá bezpečnostná výbava <br /><a href=\"/attachments/short_sk/SPORT.pdf\" target=\"_blank\">Otvoriť podrobný popis športov</a></p>" +
                "<p>Pripoistenie kryje riziká v základnom rozsahu – aj počas výkonu vymenovaných extrémnych a rizikových športov, </p>\n" +
                "<p>bez pripoistenia sú tieto aktivity nepoistené - t.j. poisťovna nenahradí liečebné náklady, trvalé následky úrazu, zodpovednosť za škody, atd. vzniknuté pri športových aktivitách.</p>\n" +
                "<p> </p>\n" +
                "<p>Pripoistenie kryje aj bežné a zimné športy, ak sú vykonávané neprofesionálne v rámci pretekov alebo súťaží – vrátane tréningov.</p>",
            linkText: 'viac INFO vo VPP KCP 05/2025 strana 28',
            page: 28
          }
        },
        PETS: {
          code: 'PETS',
          price: 1,
          label: 'Domáce zvieratá',
          tooltip: {
            description:
                "<p>Pripoistenie kryje liečebné veterinárne náklady a zodpovednosť za škodu spôsobenú domácim zvieraťom počas Vašej cesty – až do výšky 1.000 EUR</p>\n" +
                "\n" +
                "<p>Poistiť je možné domácich psov a mačky vo veku od 3 mesiacov do 10 rokov, ktorý majú Európsky pas a sú označené mikročipom alebo tetovaním, absolvovali povinné očkovania a spĺňajú všetky požiadavky pre vstup do cieľovej krajiny </p>\n" +
                "<p>Nie sú kryté veterinárne náklady na chronické alebo vrodené ochorenia zvieraťa, ani ošetrenie ktoré je možné odložiť až do návratu zo zahraničia.</p>",
            linkText: 'viac INFO vo VPP KCP 05/2025 strana 26-27',
            page: 26
          }
        },
        MANUAL_WORK: {
          travelReason: [
            'WORK'
          ],
          code: 'MANUAL_WORK',
          price: 1.2,
          label: 'Manuálna práca',
          tooltip: {
            description:
                "<p>Pripoistenie kryje škodové udalosti, vzniknuté počas výkonu manuálnej práce.</p>\n" +
                "<p>Nepoistené sú práce vykonávané bez príslušných povolení a rizikové povolania ako napríklad vojaci, herci, kaskadéri, profesionálni vodiči ako aj dlhodobé práce na viac ako 120 dní. </p>",
            linkText: 'viac INFO vo VPP KCP 05/2025 strana 23-24',
            page: 23
          },
          removeWhenOld: true
        }
      },
    }

  },
  watch: {
    localValue() {
      this.$emit('update:modelValue', this.localValue);
    },
    selectedPrice(){
      console.log('selectedPriceUpdate', {selectedPrice: this.selectedPrice});
      this.$emit('updateSelectedPrice', this.selectedPrice);
    },

    // modelValue.: function(val) {
    //   this.localValue = val;
    // }
    insurancesPersonalized(){
      //set items as selected
      console.log('insurancesPersonalized');
      this.localValue = this.recomendedPersonalizedItems.map(personalizedItem => personalizedItem.code);
    },

  },
  computed: {
    recomendedPersonalizedItems(){
      return this.insurancesPersonalized.filter((item) => {
        return item.preselected;
      });
    },
    recomendedPrice: function () {
      return this.countPrice(this.recomendedPersonalizedItems);
    },
    selectedPrice: function () {
      return this.countPrice(this.localValue.map((item) => this.insurances[item]));
    },
    insurancesPersonalized: function () {
      let self = this;
      console.log("additional items list computation start");
      if(this.product !== 'short_eu_world' ){
        console.log("zero additional items");
        return [];
      }else {
        console.log("standard additional items update");
      }
      return Object.entries(this.insurances)
          .filter(([,item]) => !item.removeWhenOld || !this.formData.age_above_70)
          .map(function ([, item]) {
            console.log({travelingBy: self.formData.traveling_by});
            return {
              ...item,
              tooltipLink: '/attachments/short_sk/VPP%20KCP%2005_2025[17].pdf#page=' + item.tooltip.page,
              preselected: self.arrayIncludesSome(item.travelReason, self.formData.travel_reason) || self.arrayIncludesSome(item.travelingBy, self.formData.traveling_by)
            }
      })
    }
  },
  methods: {
    formatCurrency(amount, currency) {
      return new Intl.NumberFormat("sk-SK", {
        style: "currency",
        maximumFractionDigits: 2,
        currency
      }).format(amount);
    },
    countPrice(items){
      let price = 0;
      items.forEach((item) => {
        price += (item.price * this.daysCount * this.formData.travellers_count * (this.formData.regional_coverage === 'WORLD' ? 2 : 1));
      })
      console.log({price, productPrice: this.productPrice});
      return this.productPrice + price;
    },
    arrayIncludesSome(arr, target) {
      return target?.filter(item => {
        return arr?.includes(item);
      }).length;
    },
  }
}
</script>

<style scoped>
.rop-t{
  a{
    display: block;

    font-size: .8em;
    line-height: 1.1;

  }
}

.tooltip{
  display: none;
}
.description{
  display: block;
}
@media  all and (min-width: 700px) {
  .tooltip{
    display: inline-block;
    margin-left: 3px;
  }
  .description{
    display: none;
  }
}
</style>